import {
    MultiYearsComparisonQueryKey,
    InscriptionQueryKey,
    VentilatedBudgetProposalQueryKey,
    BudgetProposalsQueryKey,
    ArgumentQueryKey,
    InscriptionOptionsQueryKey,
    InitialisationQueryKey,
    CadrageQueryKey,
    BudgetQueryKey,
    ProjectQueryKey,
    BudgetLineQueryKey,
} from '../createBudgetQueryKeys';
import createCustomUseQuery from '../createCustomUseQuery';

export const useArgumentQuery = createCustomUseQuery<ArgumentQueryKey>();
export const useBudgetLinesQuery = createCustomUseQuery<BudgetLineQueryKey>();
export const useBudgetQuery = createCustomUseQuery<BudgetQueryKey>();
export const useBudgetProposalsQuery =
    createCustomUseQuery<BudgetProposalsQueryKey>();
export const useCadrageQuery = createCustomUseQuery<CadrageQueryKey>();
export const useInitialisationQuery =
    createCustomUseQuery<InitialisationQueryKey>();
export const useInscriptionQuery = createCustomUseQuery<InscriptionQueryKey>();
export const useInscriptionOptionQuery =
    createCustomUseQuery<InscriptionOptionsQueryKey>();
export const useMultiYearsComparisonQuery =
    createCustomUseQuery<MultiYearsComparisonQueryKey>();
export const useVentilatedBudgetProposalQuery =
    createCustomUseQuery<VentilatedBudgetProposalQueryKey>();
export const useProjectQuery = createCustomUseQuery<ProjectQueryKey>();
